import { pushInteractionToolbarDataAnalytics } from './interactiontoolbarUtils'

const vivaengage = () => {
  const init = () => {
    const vivaengageElement = document.querySelector('.cmp-interaction-toolbar__share-vivaengage')
    const shareContainer = document.querySelector('.cmp-interaction-toolbar__share')
    
    if (vivaengageElement && shareContainer) {
      const vivaengageUrl = shareContainer.getAttribute('data-vivaengage-url')
      
      vivaengageElement.addEventListener('click', () => {
        pushInteractionToolbarDataAnalytics({
          componentName: 'share-vivaengage',
          title: 'interaction-toolbar',
        })
        
        if (vivaengageUrl) {
          window.open(vivaengageUrl, '_blank', 'noopener,noreferrer')
        }
      })
    }
  }

  return {
    init,
  }
}

export { vivaengage }
